import React, { useState, useEffect } from "react";
import { useApiContext } from 'context/ApiContext';  // Utilisation du contexte

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/photo_turbine.png";
import brandWhite from "assets/images/logo_engiegreen.png";


function Basic() {
    const [email, setEmail] = useState("");
    const [pswd, setPswd] = useState("");
    const [error, setError] = useState(false); // Etat pour gerer l'erreur visuelle

    const emailRegex = /^[\p{L}\p{N}._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/u;
    const { authentification, authError } = useApiContext();

    // Fonction pour gerer la soumission du formulaire
    const handleSubmit = (event) => {
        event.preventDefault();  // Empeche le rechargement de la page

        if (!emailRegex.test(email)) {
            setError(true);
            return;
        }
        authentification(email, pswd);  // Appelle la fonction d'authentification
    };

    useEffect(() => {
        if (authError === "INVALID VALUES") {
            setError(true);  // Active l'erreur
        } else {
            setError(false); // Desactive l'erreur
        }
    }, [authError]);

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form" onSubmit={handleSubmit}>
                        <MDBox mt={1} mb={2} textAlign="center">
                            {brandWhite && (
                                <MDBox
                                    component="img"
                                    src={brandWhite}
                                    alt="BrandWhite"
                                    width="11rem"
                                />
                            )}
                        </MDBox>
                        <MDBox textAlign="center">
                            <MDTypography variant="button" fontWeight="bold" fontSize={17} color="info">
                                &nbsp;&nbsp;Bridage Agricole WEB PLATFORM
                            </MDTypography>
                        </MDBox>
                        <MDBox mb={1}>
                            <MDInput
                                type="text"
                                label="Email"
                                fullWidth
                                value={email}
                                inputProps={{ color: "dark" }}
                                onChange={(e) => setEmail(e.target.value)}
                                error={error}
                            />
                        </MDBox>
                        <MDBox mb={1}>
                            <MDInput
                                type="password"
                                label="Password"
                                fullWidth
                                value={pswd}
                                inputProps={{ color: "dark" }}
                                onChange={(e) => setPswd(e.target.value)}
                                error={error} // Active la couleur rouge si erreur
                            />
                        </MDBox>
                        {error && (
                            <MDBox mb={1} textAlign="center">
                                <MDTypography color="error" fontSize={13}>
                                    Invalid email or password. Please try again.
                                </MDTypography>
                            </MDBox>
                        )}
                        <MDBox mt={2} mb={2}>
                            <MDButton type="submit" variant="gradient" color="info" fullWidth>
                                sign in
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default Basic;
